<template>
  <div>
    <div v-if="visible" class="modal-backdrop fade show"></div>
    <div v-if="visible" class="modal d-block" tabindex="-1" role="dialog" @keydown.esc="reject">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body">
            <slot>
              <p>{{ message }}</p>
            </slot>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="reject">{{ cancelText }}</button>
            <button type="button" class="btn btn-primary" @click="accept">{{ confirmText }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmModal",
  data() {
    return {
      visible: false,
      title: "Confirmar",
      message: "",
      confirmText: "Aceptar",
      cancelText: "Cancelar",
      resolver: null,
    };
  },
  methods: {
    open(title, message, options = {}) {
      this.title = title || this.title;
      this.message = message || this.message;
      this.confirmText = options.confirmText || this.confirmText;
      this.cancelText = options.cancelText || this.cancelText;
      this.visible = true;
      // Return a promise so callers can await the result
      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    accept() {
      this.visible = false;
      if (this.resolver) this.resolver(true);
      this.resolver = null;
      this.$emit("accepted");
    },
    reject() {
      this.visible = false;
      if (this.resolver) this.resolver(false);
      this.resolver = null;
      this.$emit("rejected");
    },
  },
};
</script>

